import Lijnnummer from "./Lijnnummer";
import Halte from "./Halte";
import GeoSearch from "./GeoSearch";
import GoogleApi from "./GoogleApi";

export default {
  geoSearch: GeoSearch,
  lijnnummer: Lijnnummer,
  halte: Halte,
  googleApi: GoogleApi,
};



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SelectSources/index.js